import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    Title
} from 'chart.js';

import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    Title
);

const backgroundColor = [
    "#1E3A8A",
    "#065F46",
    "#0D9488",
    "#F97316",
    "#2563EB",
    "#047857",
    "#14B8A6",
    "#FB923C",
    "#3B82F6",
    "#059669",
    "#2DD4BF"
];

// Genera labels yyyy-mm desde el mes actual hacia atrás
const generateMonthLabels = () => {

    const labels = [];

    const currentDate = new Date();

    for (let i = 10; i >= 0; i--) {

        const date = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() - i,
            1
        );

        const year = date.getFullYear();

        const month = String(
            date.getMonth() + 1
        ).padStart(2, '0');

        labels.push(`${year}-${month}`);
    }

    return labels;
};

const options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {

        title: {
            display: true,
            text: 'Portafolio (en miles)',
            font: {
                size: 18
            }
        },

        legend: {
            display: false
        },

        tooltip: {
            callbacks: {
                label: function (context) {
                    return `${context.parsed.y.toLocaleString('es-AR')} mil`;
                }
            }
        }
    },

    scales: {

        y: {

            beginAtZero: true,

            min: 0,
            max: 250000,

            ticks: {

                stepSize: 50000,

                callback: function (value) {
                    return value.toLocaleString('es-AR');
                }
            }
        },

        x: {
            ticks: {
                maxRotation: 45,
                minRotation: 45
            }
        }
    }
};

const PortfolioBarChart = () => {

    const labels = generateMonthLabels();

    // ejemplo datos
    const values = [
        45000,
        70000,
        90000,
        120000,
        80000,
        110000,
        140000,
        160000,
        180000,
        210000,
        190000
    ];

    const data = {

        labels,

        datasets: [
            {
                label: 'Portafolio',
                data: values,
                backgroundColor: backgroundColor,
                borderRadius: 6,
            }
        ]
    };

    return (
        <div
            style={{
                width: '100%',
                height: '400px'
            }}
        >
            <Bar
                data={data}
                options={options}
            />
        </div>
    );
};

export default PortfolioBarChart;